import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import { isApiResponse } from '../helpers/utils.js';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { css } from "@emotion/core";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;

class CSMPerformanceDrilldown extends Component {
    constructor(props) {
        super(props);
        const params = new URLSearchParams(props.location.search);
        const csm = params.get("csm") || "";
        this.state = {
            csm,
            loading: false,
            data: [],
            error: null,
        };
    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
    }

    componentDidMount() {
        this.getDrilldownData();
    }

    getDrilldownData() {
        const { csm } = this.state;
        if (!csm) {
            this.setState({ error: "Missing CSM name" });
            return;
        }
        this.setState({ loading: true });
        isApiResponse(false);

        axios.get(config.get('API_URL') + "/summaryReport/get_csm_performance_report_drill", {
            headers: { Authorization: localStorage.usertoken },
            params: { csm }
        })
        .then(response => {
            isApiResponse(true);
            if (response.data && response.data.data) {
                this.setState({
                    data: response.data.data,
                    loading: false,
                    error: null,
                });
            } else {
                this.setState({ data: [], loading: false });
            }
        })
        .catch(error => {
            isApiResponse(true);
            this.setState({
                loading: false,
                error: "Failed to load data"
            });
            console.error("CSM Drilldown API Error:", error);
        });
    }

    formatNumber(val) {
        if (val === null || val === undefined) return '-';
        return Number(val).toLocaleString('en-IN');
    }

    handleBack = () => {
        this.props.history.push("/admin/csm-performance-report");
    }

    handleExport = () => {
        const { csm, data } = this.state;
        if (!data || data.length === 0) return;

        const headers = [
            'Merchant',
            'Transactable UTIDs MTD',
            'Transactable UTIDs LMTD',
            'Transacting Stores MTD',
            'Transacting Stores LMTD',
        ];
        const escape = (val) => {
            if (val === null || val === undefined) return '';
            const s = String(val);
            return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
        };
        const rows = data.map(row => [
            row.merchant_name,
            row.transactable_utids_mtd,
            row.transactable_utids_lmtd,
            row.transacting_stores_mtd,
            row.transacting_stores_lmtd,
        ].map(escape).join(','));
        const csv = [headers.join(','), ...rows].join('\r\n');

        const blob = new Blob(["﻿" + csv], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        const safeCsm = (csm || 'csm').replace(/[\\/:*?"<>|]+/g, '_').trim();
        a.href = url;
        a.download = `csm_performance_${safeCsm}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    render() {
        const { csm, loading, error, data } = this.state;

        const backBtnStyle = {
            background: '#f3f4f6',
            border: '1px solid #d1d5db',
            color: '#111827',
            padding: '6px 12px',
            borderRadius: '4px',
            fontSize: '13px',
            fontWeight: 600,
            cursor: 'pointer',
        };

        const header = (
            <div className="col-md-9 no-padd">
                <div className="header" style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <button
                        type="button"
                        onClick={this.handleBack}
                        style={backBtnStyle}
                    >
                        &larr; Back
                    </button>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <h4 className="title" style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#111827', letterSpacing: '0.2px' }}>
                            CSM Performance Report
                        </h4>
                        <span style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>
                            {csm || '-'}
                        </span>
                    </div>
                </div>
            </div>
        );

        if (loading) {
            return (
                <div className="content-invoice">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    {header}
                                    <div className="clearfix"></div>
                                    <div className="content">
                                        <BeatLoader css={override} size={15} color={"#51bcda"} loading={loading} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="content-invoice">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    {header}
                                    <div className="clearfix"></div>
                                    <div className="content">
                                        <div className="alert alert-danger">{error}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                {header}
                                <div className="col-md-3 pull-right" style={{ paddingTop: '15px', textAlign: 'right' }}>
                                    <button
                                        type="button"
                                        onClick={this.handleExport}
                                        disabled={!data || data.length === 0}
                                        className="btn btn-primary btn-sm"
                                        style={{ backgroundColor: '#5e35b1', borderColor: '#5e35b1' }}
                                    >
                                        <i className="fa fa-download" aria-hidden="true"></i>&nbsp; Export to CSV
                                    </button>
                                </div>
                                <div className="clearfix"></div>

                                <div className="content">
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table className="table table-striped table-hover">
                                            <thead>
                                                <tr style={{ backgroundColor: '#5e35b1', color: 'white' }}>
                                                    <th rowSpan={2}>Merchant</th>
                                                    <th colSpan={2} style={{ textAlign: 'center', borderLeft: '1px solid rgba(255,255,255,0.3)' }}>
                                                        Transactable UTIDs
                                                    </th>
                                                    <th colSpan={2} style={{ textAlign: 'center', borderLeft: '1px solid rgba(255,255,255,0.3)' }}>
                                                        Transacting Stores
                                                    </th>
                                                </tr>
                                                <tr style={{ backgroundColor: '#5e35b1', color: 'white' }}>
                                                    <th style={{ borderLeft: '1px solid rgba(255,255,255,0.3)' }}>MTD Achievement</th>
                                                    <th>LMTD Achievement</th>
                                                    <th style={{ borderLeft: '1px solid rgba(255,255,255,0.3)' }}>MTD Achievement</th>
                                                    <th>LMTD Achievement</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={5} style={{ textAlign: 'center' }}>No data available</td>
                                                    </tr>
                                                ) : (
                                                    data.map((row, idx) => (
                                                        <tr key={idx}>
                                                            <td><strong>{row.merchant_name}</strong></td>
                                                            <td>{this.formatNumber(row.transactable_utids_mtd)}</td>
                                                            <td>{this.formatNumber(row.transactable_utids_lmtd)}</td>
                                                            <td>{this.formatNumber(row.transacting_stores_mtd)}</td>
                                                            <td>{this.formatNumber(row.transacting_stores_lmtd)}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="footer">
                                    <div className="stats">
                                        <i className="fa fa-info-circle"></i>
                                        Total Records: {data.length}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        currentMenu: (name) => { dispatch({ type: 'change_menu', payload: name }) }
    }
}

export default withRouter(connect(null, mapDispatchToProps)(CSMPerformanceDrilldown));
